import {FC} from 'react'
import moment from 'moment'
import {useHistory} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {asyncError} from 'store/actions/asyncError'
import {useUpdateProcedureStatus} from 'hooks/api/procedureStatuses'
import Button from 'jbc-front/components/Button'
import {EmployeeName} from '../../parts/EmployeeName'
import {Form} from '../Form'
import {schema, Schema} from '../Form/schema'
import {ProcedureStatus, Employee, UPDATE_PROCEDURE_CHANGE_OFFICE_DATUM} from './query'
import {CREATE_PROCEDURE_CHANGE_OFFICE_DATUM} from '../detail/query'

// @ts-ignore
import {useMutation} from 'components/Graphql'

interface PresenterProps {
  employee: Employee
  procedureStatus: ProcedureStatus
}

export const Presenter: FC<PresenterProps> = ({employee, procedureStatus}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const updateProcedureStatus = useUpdateProcedureStatus()
  const procedureChangeOfficeDatum = procedureStatus?.procedureChangeOfficeDatum
  const [updateProcedureChangeOffice] = useMutation(UPDATE_PROCEDURE_CHANGE_OFFICE_DATUM)
  const [createProcedureChangeOffice] = useMutation(CREATE_PROCEDURE_CHANGE_OFFICE_DATUM)

  const methods = useForm({
    resolver: yupResolver(schema),
    reValidateMode: 'onBlur',
    defaultValues: {
      procedureStatusId: procedureChangeOfficeDatum?.procedureStatusId,
      beforeOfficeId: procedureChangeOfficeDatum?.beforeOfficeId,
      afterOfficeId: procedureChangeOfficeDatum?.afterOfficeId,
      relocateOn: moment(procedureChangeOfficeDatum?.relocateOn).format('L'),
    },
  })
  const {handleSubmit, setError} = methods

  const onSubmit = async (data: Schema) => {
    try {
      await updateProcedureStatus(procedureStatus.id, {dateOn: data.relocateOn})
      const procedureStatusId = procedureStatus.id
      const post = procedureChangeOfficeDatum ? updateProcedureChangeOffice : createProcedureChangeOffice
      await post({
        variables: {
          input: {
            procedureStatusId,
            beforeOfficeId: data.beforeOfficeId,
            afterOfficeId: data.afterOfficeId,
            relocateOn: data.relocateOn,
          },
        },
      })

      history.push(`/procedure_statuses/${procedureStatus.id}`)
    } catch (err) {
      if (err.errors?.afterOfficeId) {
        setError('afterOfficeId', {type: 'custom', message: err.errors.afterOfficeId})
      } else if (err.response && err.response.status === 422) {
        const dateOnError = err.response.data._errors?._base?.date_on
        dateOnError && setError('relocateOn', {type: 'custom', message: dateOnError[0]})
      } else {
        dispatch(asyncError(err))
      }
    }
  }

  return (
    <>
      <div className="l-title-wrap">
        <h1 className="m-title-main">転勤情報</h1>
        <EmployeeName employee={employee} />
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormProvider {...methods}>
          <Form />
        </FormProvider>

        <div className="u-ta-c u-mt30">
          <Button primary onClick={handleSubmit(onSubmit)}>
            保存
          </Button>
        </div>
      </form>
    </>
  )
}
